import { render, staticRenderFns } from "./MakeupArtists.vue?vue&type=template&id=c2da79e4"
import script from "./MakeupArtists.vue?vue&type=script&lang=js"
export * from "./MakeupArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports